const downloadedFonts = []

/**
 * Transform the font's name to a valid selector (make the name lowercase and replace spaces with
 * dashes)
 */
export function getFontSelector ( font ) {
  return font.family.replace( /\s+/g, '-' ).toLowerCase()
}

/**
 * Generate the URL to the Google Fonts stylesheet of the specified font
 */
function getDownloadURL ( font, variants, onlyCharacters ) {
  if ( !onlyCharacters ) {
    //Check if the font has already been downloaded
    for ( let index in downloadedFonts ) {
      if ( downloadedFonts[index] === font ) return
    }
    downloadedFonts.push( font )
  }

  // Base URL
  let url = 'https://fonts.googleapis.com/css?family='
  // Font name
  if ( typeof font === 'string' ) {
    url += font.replace( / /g, '+' )
  } else {
    url += font.family.replace( / /g, '+' )
  }

  if ( url.indexOf( 'Verdana' ) !== -1 ) {
    return null
  }

  // Font variants
  url += `:${variants[0]}`
  for ( let i = 1; i < variants.length; i += 1 ) {
    url += `,${variants[i]}`
  }
  // Only download characters in the font name if onlyCharacters is true
  if ( !!onlyCharacters ) {
    // Remove spaces and duplicate letters from the font name
    let downloadChars = font.family
    downloadChars = downloadChars.replace( /\s+/g, '' )
    downloadChars = downloadChars
      .split( '' )
      .filter( ( x, n, s ) => s.indexOf( x ) === n )
      .join( '' )
    url += `&text=${downloadChars}`
  }
  return url
}

/**
 * Add Google Fonts stylesheet for the specified font family and variants
 */
export function downloadFullFont ( font, fontSelector, variants, onChange ) {
  // magazine application default font
  if ( /Muli|Lato/gi.test( font.family ) ) return

  const url = getDownloadURL( font, variants, false )

  if ( !url ) return

  // Add the stylesheet to the document head
  const link = document.createElement( 'link' )
  link.rel = 'stylesheet'
  link.href = url
  link.id = `font-full-${fontSelector}`
  link.setAttribute( 'crossorigin', 'anonymous' )
  link.className = 'google-fonts'
  if ( onChange ) {
    // If onChange function is specified: execute it once the stylesheet has loaded
    link.onload = () => {
      onChange( font )
    }
  }
  document.head.appendChild( link )
}

export function setCustomFonts ( font, path ) {
  let style = document.createElement( 'style' )
  /* eslint-disable */
  style.innerHTML += `@font-face {  font-family: '` + font + `';  src: url('https://cheetah-templates.builderall.com/storage/` + path + `') format('` + extensionFont( path ) + `'); }`;
  document.head.appendChild( style )
}

function extensionFont( path ) {
  if ( path.indexOf( 'ttf' ) !== -1 ) {
    return 'truetype';
  }
  if (path.indexOf( 'otf' ) !== -1) {
    return 'opentype';
  }
  if ( path.indexOf( 'woff2' ) !== -1 ) {
    return 'woff2';
  }
  if ( path.indexOf( 'woff' ) !== -1 ) {
    return 'woff';
  }
  return 'truetype';
}

/**
 * Add limited Google Fonts stylesheet for the specified font family (only containing the characters
 * which are needed to write the font family name)
 */
export function downloadPreviewFont ( font, fontSelector, variants ) {
  // magazine application default font
  if ( /Muli|Lato/gi.test( font.family ) ) return

  const url = getDownloadURL( font, variants, true )

  if ( !url ) return

  const _id = `font-preview-${fontSelector}`
  const checkFont = document.getElementById( _id )

  if ( checkFont ) return

  // Add the stylesheet to the document head
  const link = document.createElement( 'link' )
  link.rel = 'stylesheet'
  link.href = url
  link.id = `font-preview-${fontSelector}`
  link.setAttribute( 'crossorigin', 'anonymous' )
  document.head.appendChild( link )
}

/**
 * Check whether the full font needs to be downloaded and do so if necessary. Afterwards, execute
 * the onChange function
 */
export function checkFullFont ( font, variants, onChange ) {
  const fontSelector = getFontSelector( font )

  if ( document.getElementById( `font-preview-${fontSelector}` ) ) {
    // If preview font is available: replace it with the full font
    document.getElementById( `font-preview-${fontSelector}` ).outerHTML = '' // remove tag
    downloadFullFont( font, fontSelector, variants, onChange )
  } else if ( !document.getElementById( `font-full-${fontSelector}` ) ) {
    // If font is not available: download it
    downloadFullFont( font, fontSelector, variants, onChange )
  } else if ( onChange ) {
    // If font is available: execute onChange function if it is specified
    onChange( font )
  }
}

/**
 * Check whether the preview font needs to be downloaded and do so if necessary
 */
export function checkPreviewFont ( font, variants ) {
  const fontSelector = getFontSelector( font )

  // If full font is not available: download preview font
  if ( !document.getElementById( `font-full-${fontSelector}` ) ) {
    downloadPreviewFont( font, fontSelector, variants )
  }
}



// WEBPACK FOOTER //
// ./src/components/commons/FontManager/fontDownload.js